import script from "./SnoozeEndedModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SnoozeEndedModal.vue?vue&type=script&setup=true&lang=ts"

import "./SnoozeEndedModal.vue?vue&type=style&index=0&id=62965247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62965247"]])

export default __exports__